import React from 'react';

const STEPS = ['New Request', 'Review & Match', 'Customer & Shipping', 'Summary & Submit'];

// Plain-CSS numbered stepper, adapted from PurchaseOnBehalfTab.jsx's StepIndicator
// for visual consistency (this app doesn't use antd's Steps component anywhere).
const StepIndicator = ({ current, maxReached, onJump }) => {
  return (
    <div style={{ display: 'flex', gap: 0, marginBottom: 28, overflowX: 'auto' }}>
      {STEPS.map((label, i) => {
        const done = i < current;
        const active = i === current;
        const reachable = i <= maxReached;
        return (
          <React.Fragment key={label}>
            <div
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: 96, flex: 1,
                cursor: reachable ? 'pointer' : 'default',
              }}
              onClick={() => { if (reachable && onJump) onJump(i); }}
            >
              <div style={{
                width: 32, height: 32, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontWeight: 700, fontSize: 14,
                background: done ? '#057a55' : active ? '#1a56db' : '#e5e7eb',
                color: done || active ? '#fff' : '#6b7280',
                transition: 'all .2s',
              }}
              >
                {done ? <i className="bi bi-check-lg" aria-hidden="true" style={{ fontSize: 14 }} /> : i + 1}
              </div>
              <span style={{
                fontSize: 12, marginTop: 4, textAlign: 'center',
                color: active ? '#1a56db' : done ? '#057a55' : '#9ca3af',
                fontWeight: active ? 700 : 400,
              }}
              >
                {label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div style={{ flex: 1, height: 2, alignSelf: 'center', background: done ? '#057a55' : '#e5e7eb', marginBottom: 20, transition: 'background .2s' }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default StepIndicator;
